
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/board-of-directors",
      function () {
        return require("private-next-pages/about-us/board-of-directors.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/board-of-directors"])
      });
    }
  